import { Link } from "react-router-dom";
import styles from "./Unauthorized.module.css";

export default function Unauthorized() {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.code}>403</div>
        <h1>You don't have permission to access this page.</h1>
        <p>If you believe this is an error, please contact your administrator.</p>
        <Link to="/" className={styles.homeLink}>
          Go to Home
        </Link>
      </div>
    </div>
  );
}
